module.exports = __webpack_public_path__ + "static/media/FlowerAILogo.c3cf14e2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Logo/FlowerAILogo.svg
// module id = 547
// module chunks = 0